// @ts-nocheck
import React from "react";

const LineClamp = ({ text, maxLines, minLines = 0, textSx }) => {
  const [isOverflowing, setIsOverflowing] = React.useState(false);
  const containerRef = React.useRef(null);

  const isTextOverflowing = () => {
    const container = containerRef.current;
    if (container) {
      return container.scrollHeight > container.clientHeight;
    }
    return false;
  };
  React.useEffect(() => {
    setIsOverflowing(isTextOverflowing());
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [text]);

  const handleResize = () => {
    setIsOverflowing(isTextOverflowing());
  };

  return (
    <span
      ref={containerRef}
      style={{
        display: "-webkit-inline-box",
        WebkitBoxOrient: "vertical",
        WebkitLineClamp: maxLines,
        overflow: "hidden",
        textOverflow: "ellipsis",
        maxWidth: "100%",
        verticalAlign: "top",
        minHeight: `${minLines * 1.2}em`,
        ...textSx,
      }}
    >
      {text}
    </span>
  );
};

export default LineClamp;